import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { createdBy } from '~components/Job/AuditDetails/utils';
import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { FileAttachment } from '~hooks/useFileAttachment/models';

interface UploadedByColumnProps {
  file: FileAttachment;
  sx?: SxProps<Theme>;
}

export default function UploadedByColumn({ file, sx }: UploadedByColumnProps) {
  const { uploadedBy } = file;

  return (
    <Box sx={{ ...sx, overflow: 'hidden' }}>
      <OverflowAwareText>{createdBy(uploadedBy)}</OverflowAwareText>
    </Box>
  );
}
